/**
 * /policies/grading-agent — Grading agent (Pack 14 v2).
 */
import { PageHeader } from "../components/ui";
import { AgentBadge } from "../components/ui/AgentBadge";

export function GradingAgentPage() {
  return (
    <div className="space-y-6">
      <PageHeader
        title="Grading Agent"
        subtitle="Tashghil drives grade promotions; Khidmat answers career-path questions."
      />
      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3"><AgentBadge agent="tashghil" /><h3 className="text-base font-semibold">Tashghil — grade ladder</h3></div>
        <p className="text-sm text-text-secondary">Promotion proposals with auto-compute new compensation. Inherits from grade entitlement bundle (M13). Routes per approval chain.</p>
      </section>
      <section className="bg-surface-default border border-border-default rounded-lg p-4">
        <div className="flex items-center gap-2 mb-3"><AgentBadge agent="khidmat" /><h3 className="text-base font-semibold">Khidmat — career path</h3></div>
        <p className="text-sm text-text-secondary">Employee asks "What's my career path?" via WhatsApp / chat. Khidmat consults the grade ladder + delegates to Tashghil for promotion-readiness assessment.</p>
      </section>
    </div>
  );
}
